import { InvalidTimestampFormatError } from '../../errors';

/**
 * Returns a formatted epoch timestamp as mm/dd/yy HH:MM:SS AM/PM.
 * @param {Number} timestamp - The epoch time to format in milliseconds (ms)
 */
const formatTimestamp = timestamp => {
  if (typeof timestamp !== 'number' || Number.isNaN(timestamp)) {
    throw new InvalidTimestampFormatError();
  }
  const ts = timestamp;
  const date = new Date(ts);
  const currentTime = new Date(ts).toLocaleTimeString();
  const dd = date.getDate();
  const mm = date.getMonth() + 1;
  const yy = date.getFullYear();
  return `${mm}/${dd}/${yy} ${currentTime}`;
};

export default formatTimestamp;
